import React, { lazy } from "react";
import LoginIcon from "@mui/icons-material/Login";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TicketIcon from "@mui/icons-material/Assignment";
import ReportIcon from "@mui/icons-material/Assessment";
import RegisterIcon from "@mui/icons-material/PersonAdd";
import PasswordRecoveryIcon from "@mui/icons-material/LockReset";
import ResetPasswordIcon from "@mui/icons-material/Lock";
import BellIcon from "@mui/icons-material/Notifications";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import BusinessIcon from "@mui/icons-material/Business";
const Login = lazy(() => import("./components/Login"));
const Register = lazy(() => import("./components/Register"));
const PasswordRecovery = lazy(() => import("./components/PasswordRecovery"));
const ResetPassword = lazy(() => import("./components/ResetPassword"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const UserDashboard = lazy(() => import("./pages/UserDashboard"));
const ExecutiveDashboard = lazy(() => import("./pages/ExecutiveDashboard"));
const DepartmentHeadDashboard = lazy(() =>
  import("./pages/DepartmentHeadDashboard")
);
const DepartmentTicket = lazy(() =>
  import("./pages/DepartmentTicket")
);
const UserManagement = lazy(() => import("./pages/UserManagement"));
const Reports = lazy(() => import("./pages/Reports"));
const Analytics = lazy(() => import("./pages/Analytics"));
const Tickets = lazy(() => import("./pages/Tickets"));
const NotificationPage = lazy(() => import("./pages/NotificationPage"));
const Locations = lazy(() => import("./pages/Locations"));
const Department = lazy(() => import("./pages/Department"));
const Profile = lazy(() => import("./pages/Profile"));
const AllAssignedTickets = lazy(() =>
  import("./pages/AllAssignedTickets")
);
const routes = [
  {
    name: "Login",
    icon: <LoginIcon />,
    path: "/",
    component: Login,
    exact: true,
  },
  {
    name: "Register",
    icon: <RegisterIcon />,
    path: "/register",
    component: Register,
    exact: true,
  },
  {
    name: "Password Recovery",
    icon: <PasswordRecoveryIcon />,
    path: "/password-recovery",
    component: PasswordRecovery,
    exact: true,
  },
  {
    name: "Reset Password",
    icon: <ResetPasswordIcon />,
    path: "/reset-password",
    component: ResetPassword,
    exact: true,
  },
  {
    name: "Profile",
    icon: <RegisterIcon />,
    path: "/dashboard/profile",
    component: Profile,
    exact: true,
  },
  {
    name: "Admin Dashboard",
    icon: <DashboardIcon />,
    path: "/dashboard/admin",
    component: AdminDashboard,
  },
  {
    name: "User Dashboard",
    icon: <DashboardIcon />,
    path: "/dashboard/user",
    component: UserDashboard,
  },
  {
    name: "Executive Dashboard",
    icon: <DashboardIcon />,
    path: "/dashboard/executive",
    component: ExecutiveDashboard,
  },
  {
    name: "Department Head Dashboard",
    icon: <DashboardIcon />,
    path: "/dashboard/department-head",
    component: DepartmentHeadDashboard,
  },
  {
    name: "User Management",
    icon: <TicketIcon />,
    path: "/dashboard/user-management",
    component: UserManagement,
  },
  {
    name: "Reports",
    icon: <ReportIcon />,
    path: "/dashboard/reports",
    component: Reports,
  },
  {
    name: "Analytics",
    icon: <ReportIcon />,
    path: "/dashboard/analytics",
    component: Analytics,
  },
  {
    name: "Tickets",
    icon: <TicketIcon />,
    path: "/dashboard/tickets",
    component: Tickets,
  },
  {
    name: "Notifications",
    icon: <BellIcon />,
    path: "/dashboard/notifications",
    component: NotificationPage,
  },
  {
    name: "Locations",
    icon: <AddLocationAltIcon />,
    path: "/dashboard/locations",
    component: Locations,
  },
  {
    name: "Department",
    icon: <BusinessIcon />,
    path: "/dashboard/department",
    component: Department,
  },
    {
    name: "DepartmentTicket",
    icon: <BusinessIcon />,
    path: "/dashboard/department-ticket",
    component: DepartmentTicket,
  },
     {
    name: "AllAssignedTickets",
    icon: <TicketIcon />,
    path: "/dashboard/assigned-tickets",
    component: AllAssignedTickets,
  },
];

export default routes;
